// extracted by mini-css-extract-plugin
module.exports = {"root":"jqPFly","title":"rfCJH2","inputContainer":"yqRsps","textbox":"Hro2wt","textboxForm":"H+QZ3P","cancel":"_8-28VX","animated":"oAbeqz","shake":"_3q2XXP"};